module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "",
      "navbar-default": "",
      "navbar-fixed-top": ""
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../assets/logo_handson_sm.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/logo_eit_sm.png")
    }
  })])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [(_vm.privAdministrator) ? _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Manage"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/countries"
    }
  }, [_vm._v("Countries")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/programs"
    }
  }, [_vm._v("Programs")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/universities"
    }
  }, [_vm._v("Universities")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/studentfees"
    }
  }, [_vm._v("Student Fees")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/milestones"
    }
  }, [_vm._v("Milestones")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/events"
    }
  }, [_vm._v("Log Events")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/config"
    }
  }, [_vm._v("Configuration")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Users")])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Students"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/students"
    }
  }, [_vm._v("Students Overview")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/contracts"
    }
  }, [_vm._v("Contracts Overview")])], 1)], 1), _vm._v(" "), _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Invoicing"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/invoices/planned"
    }
  }, [_vm._v("Planned Invoices")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/invoices/numbered"
    }
  }, [_vm._v("Numbered Invoices")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/invoices/creditnote"
    }
  }, [_vm._v("Credit Notes")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/invoicepayments"
    }
  }, [_vm._v("Invoice Payments")])], 1)], 1), _vm._v(" "), _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Payments"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/scholarshippayments/planned"
    }
  }, [_vm._v("Planned Payments")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/scholarshippayments/numbered"
    }
  }, [_vm._v("Numbered Payments")])], 1)], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "userinfo"
  }, [_vm._v(_vm._s(_vm.userInfo))]), _vm._v(" "), _c('p', {
    staticClass: "versioninfo"
  }, [_vm._v(_vm._s(_vm.versionInfo))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.$auth.logout();
        _vm.$router.push('/login')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-779d627d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BarTop.vue
// module id = 713
// module chunks = 1